import { c as _c } from "react/compiler-runtime";
import './calendar-icon.scss';
import { parseCalendarDate } from '@sola/shared-utils/date.ts';
export type CalendarIconProps = {
  /** ISO date-only string in `YYYY-MM-DD` format. */
  date: string;
};
export const CalendarIcon: React.FC<CalendarIconProps> = t0 => {
  const $ = _c(11);
  const {
    date
  } = t0;
  let month;
  let t1;
  let t2;
  if ($[0] !== date) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const parsedDate = parseCalendarDate(date);
      if (!parsedDate) {
        t2 = null;
        break bb0;
      }
      month = parsedDate.toLocaleString(undefined, {
        month: "short"
      }).toUpperCase();
      t1 = parsedDate.getDate();
    }
    $[0] = date;
    $[1] = month;
    $[2] = t1;
    $[3] = t2;
  } else {
    month = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const day = t1;
  let t3;
  if ($[4] !== month) {
    t3 = <div className="CalendarIcon__month flex items-center justify-center px-snug-xl pt-snug-sm pb-snug-xs md:py-snug-md label-potent-sm">{month}</div>;
    $[4] = month;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== day) {
    t4 = <div className="CalendarIcon__day flex items-center justify-center px-snug-xl pt-snug-xs pb-snug-sm md:py-snug-sm label-potent-md">{day}</div>;
    $[6] = day;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="CalendarIcon flex rounded-md">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};